import { Grid, Card, Paper, Container } from "@mui/material"
import { Header, LoadingWrapper, SmallerHeader } from "ui"
// import { CompanyGeneralStats, CompanyGeneralStatsProps } from "ft-shared-graphql"
import { useQuery } from "@apollo/client"
import { GET_COMPANY_STATS } from "../../features/graphql/query"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { SessionFreqTable } from "../SessionPages/components/SessionsFreqTable"
import { countTypeOfSession, getEarliestSubStart, getLatestSubStart } from "../SessionPages/tools/SessionTools"


export default function CompanyStatsPage({ onBack }: { onBack: () => void }) {
    const { id } = useParams()
    const navigate = useNavigate()
    // const [companyStatsForm, setCompanyStatsForm] = useState<CompanyGeneralStatsProps>({
    //     userInfo: {
    //         paidUsers: 0,
    //         activeUsers: 0,
    //     },
    //     completionStats: {
    //         totalCompleteSessions: 0,
    //         totalPartialSessions: 0,
    //         totalUnusableSessions: 0,
    //     },
    //     typeStats: {
    //         localSessions: 0,
    //         remoteSessions: 0,
    //         tweenScreen: 0,
    //         tScreen: 0,
    //     },
    //     dataStats: {
    //         crises: 0
    //     }
    // })
    const [subDates, setSubDates] = useState<{
        startDate: Date | null,
        endDate: Date | null,
    }>({
        startDate: null,
        endDate: null
    })

    const { loading, data } = useQuery(GET_COMPANY_STATS, {
        variables: {
            id: id
        }
    })
    useEffect(() => {
        if (data) {
            // setCompanyStatsForm((prevState) => {
            //     return {
            //         ...prevState,
            //         userInfo: {
            //             paidUsers: data?.company?.paidUsers ?? 0,
            //             activeUsers: data?.company?.activeUsers ?? 0,
            //         },
            //         completionStats: {
            //             totalCompleteSessions: countTypeOfSession({ sessionStatus: "Complete", sessions: data?.company?.sessions }).length,
            //             totalPartialSessions: countTypeOfSession({ sessionStatus: "Partial", sessions: data?.company?.sessions }).length,
            //             totalUnusableSessions: countTypeOfSession({ sessionStatus: "Unusable", sessions: data?.company?.sessions }).length,
            //         },
            //         typeStats: {
            //             localSessions: countTypeOfSession({ sessionStatus: "Local", sessions: data?.company?.sessions }).length,
            //             remoteSessions: countTypeOfSession({ sessionStatus: "Remote", sessions: data?.company?.sessions }).length,
            //             tweenScreen: countTypeOfSession({ sessionStatus: "TweenScreen", sessions: data?.company?.sessions }).length,
            //             tScreen: countTypeOfSession({ sessionStatus: "tScreen", sessions: data?.company?.sessions }).length,
            //         },
            //         dataStats: {
            //             crises: countTypeOfSession({ sessionStatus: "Crises", sessions: data?.company?.sessions }).length
            //         }
            //     }
            // })
            setSubDates((prevState) => {
                const startDate = getEarliestSubStart(data?.company?.companySubscriptions)
                const endDate = getLatestSubStart(data?.company?.companySubscriptions)
                return {
                    ...prevState,
                    startDate: startDate.startDate,
                    endDate: endDate.endDate
                }
            })
        }
    }, [data, loading])

    return (
        <LoadingWrapper loading={loading}>
            <Card elevation={4}
                style={{
                    width: "100%",
                    display: "flex", padding: "16px", height: "auto"
                }}>
                <Grid container spacing={2} sx={{ flex: 1 }}>
                    <Grid size={12} padding={0}>
                        <Grid container spacing={0} sx={{ border: "none", borderBottom: "2px solid rgb(209 213 219)" }}>
                            <Grid size={6}>
                                <Header title={data?.company?.name} onBack={onBack} disableDivider />
                            </Grid>
                            <Grid size={6}>
                                <SmallerHeader entityId='1' startDate={subDates.startDate} endDate={subDates.endDate} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={6}>
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Paper component="div" variant="outlined">
                                            <Container id="helo" >
                                                {/* <CompanyGeneralStats
                                                    userInfo={companyStatsForm.userInfo}
                                                    completionStats={companyStatsForm.completionStats}
                                                    typeStats={companyStatsForm.typeStats}
                                                    dataStats={companyStatsForm.dataStats}
                                                /> */}
                                            </Container>
                                        </Paper>
                                    </Grid>
                                    <Grid size={12}>
                                        {/* <SessionStatComponent /> */}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid size={6}>
                                <Paper component="div" variant="outlined">
                                    <SessionFreqTable companyStartDate={subDates.startDate} />
                                </Paper>
                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>
            </Card>
        </LoadingWrapper>
    )
}